import Vue from 'vue'
import { getApiBasePath } from '@/constants'

export const saveTripleData = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/order/saveTripleData`, params)
  return response.data
}

export const preOrder = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/order/wxPreOrder`, params)
  return response.data
}

export const fetchPayConfirmInfo = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/order/payConfirmInfo`, params)
  return response.data
}

export const sendSmsCode = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/order/bookingCode`, params)
  return response.data
}

export const fetchBookingInfo = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/order/fetchBooking`, params)
  return response.data
}

export const confirmVisit = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/order/confirmVisit`, params)
  return response.data
}

export const fetchLoanInfo = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/order/fetchLoanInfo`, params)
  return response.data
}

export const commitStatus = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/order/commitStatus`, params)
  return response.data
}

export const saveEvent = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/order/saveEvent`, params)
  return response.data
}

export const fetchEvents = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/order/listEvent`, params)
  return response.data
}

export const sendCode = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/app/smsCode`, params)
  return response.data
}

export const login = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/app/login`, params)
  return response.data
}